<template>
  <div class="mb-5 w-100 h-100">
      <component
        v-if="component"
        :is="component"
        :id="widget?.id"
        :loading="processing"
        :start="start"
        :end="end"
        :title="widget?.type[locale]"
        :loadStats="loadWidgetStatData"
        :remove="deleteWidget"
      />
  </div>
</template>

<script setup>
import { computed, defineProps, ref, watch } from 'vue'
import { useStore } from 'vuex'
import { useWidgetBuilder } from '@/composables/widget/useWidgetBuilder'
import { useLocales } from '@/composables/locales'
import {useSwal} from "@/composables/useSwal";

const store = useStore()
const {locale} = useLocales()
const {showSwal} = useSwal()

const props = defineProps({
  widget: { type: Object, required: true },
  start: { type: Date, required: false },
  end: { type: Date, required: false },
})

const processing = ref(false)

const component = computed(() => useWidgetBuilder(props.widget?.type?.value))

async function loadWidgetStatData(params) {
  processing.value = true
  try {
    const res = await store.dispatch('stats/loadWidget', params) 
    return res.data.data
  } finally {
    processing.value = false
  }
}

async function deleteWidget() { 
  showSwal(
      i18n.global.t('stats.swal.delete'),
      i18n.global.t('stats.swal.delete_message')
  ).then( async (result) => {
    if (result.value) {
      const res = await store.dispatch('stats/deleteWidget', props.widget?.id) 
      loadData()
    }
  });

  
}

const loadData = () => {
  store.dispatch('stats/loadUserWidgets') 
  store.dispatch('stats/loadWidgets')

}

</script>

<style >
.btn-close:hover {
    color: red;
    text-decoration: none;
    opacity: .75;
}

</style>
